<template>
    <CRow>
        <CCol>
            <CCard v-if="entity">
                <CCardHeader>
                    <strong>{{ entity.title }}</strong>
                </CCardHeader>

                <CCardBody>
                    <AssistantServiceTabLinks />

                    <div class="flex items-center mt-4">
                        <div class="w-1/4">
                            <CSelect
                                class="mb-0"
                                horizontal
                                :value.sync="selectedExtraId"
                                :options="filteredExtras"
                                placeholder="Выберите опцию..."
                            />
                        </div>

                        <CButton
                            :color="selectedExtraId ? 'primary' : 'secondary'"
                            :class="{ 'cursor-not-allowed': !selectedExtraId }"
                            class="ml-6"
                            @click="onAddExtra(selectedExtraId)"
                        >Добавить</CButton
                        >
                    </div>

                    <Draggable
                        v-model="extras"
                        tag="div"
                        class="mt-4">
                        <div
                            v-for="item in extras"
                            :key="item.id"
                            class="flex items-center h-10 px-2 py-4 border-t border-gray-300"
                        >
                            <div class="w-1/4">
                                <CIcon
                                    :height="24"
                                    :content="cilCursorMove"
                                    class="handle" />
                            </div>

                            <div class="w-2/4">{{ item.title }}</div>

                            <div class="w-1/4">
                                <CButton @click="removeExtra(item.id)">
                                    <CIcon
                                        :height="12"
                                        :content="cilTrash"
                                        class="handle" />
                                </CButton>
                            </div>
                        </div>
                    </Draggable>
                </CCardBody>

                <CCardFooter>
                    <CButton color="primary" @click.prevent="submit">Сохранить</CButton>
                </CCardFooter>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import to from 'await-to-js';
    import Draggable from 'vuedraggable';
    import { cilCursorMove, cilTrash } from '@coreui/icons';

    import AssistantServiceTabLinks from '@/components/assistant/AssistantServiceTabLinks';

    export default {
        components: {
            Draggable,
            AssistantServiceTabLinks,
        },

        data: () => ({
            cilCursorMove,
            cilTrash,
            entity: undefined,
            selectedExtraId: null,
            extras: [],
            allExtras: [],
        }),

        computed: {
            filteredExtras() {
                if (Array.isArray(this.extras)) {
                    const extrasIdList = this.extras.map(item => item.id);
                    return this.allExtras.filter(
                        item => !extrasIdList.includes(item.id)
                    );
                }

                return this.allExtras;
            },
        },

        async created() {
            await Promise.all([this.fetchEntity(), this.fetchExtras()]);
        },

        methods: {
            async fetchEntity() {
                const { id, service_id } = this.$route.params;

                const [error, result] = await to(
                    this.axios.get(`/assistants/${id}/services/${service_id}`)
                );

                if (error) {
                    return this.$root.$emit('showError', 'Ошибка при получении услуги. ' + error);
                }

                this.entity = result.data;

                this.extras = result.data.extras.map(item => ({
                    ...item,
                    label: item.title,
                    value: item.id,
                }));
            },

            async fetchExtras() {
                const { id } = this.$route.params;
                const [error, result] = await to(
                    this.axios.get(`/assistants/${id}/extras`)
                );

                if (error) {
                    return this.$root.$emit('showError', 'Ошибка при получении вариантов. ' + error);
                }

                this.allExtras = result.data.map(item => ({
                    ...item,
                    label: item.title,
                    value: item.id,
                }));
            },

            async submit() {
                const { id, service_id } = this.$route.params;

                const extras = this.extras.map((item, idx) => ({
                    id: item.id,
                    position: idx + 1,
                }));

                const [error] = await to(
                    this.axios.post(`/assistants/${id}/services/${service_id}/extras`, {
                        extras,
                    })
                );

                if (error) {
                    return this.$root.$emit('showError', 'Ошибка при сохранении вариантов. ' + error);
                } else {
                    this.$router.push(`/assistants/${id}/service/${service_id}`);
                }
            },

            onAddExtra(id) {
                if (!id) {
                    return false;
                }

                const extra = this.filteredExtras.find(item => item.id === id);

                if (extra) {
                    this.extras.push({
                        id: extra.id,
                        title: extra.title,
                    });
                    this.selectedExtraId = null;
                }
            },

            removeExtra(id) {
                const idx = this.extras.findIndex(item => item.id === id);

                if (idx === -1) {
                    return false;
                }

                this.extras.splice(idx, 1);
            },
        },
    };
</script>
